(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[632],{

/***/ 94404:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal",
      function () {
        return __webpack_require__(79207);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ portal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/app/utilities/validators.ts
var Validators = {
    email: {
        required: true,
        validate: {
            // eslint-disable-next-line no-control-regex
            isValidCharset: function(value) {
                return /^[\u0000-\u00ff]+$/.test(value) || "Illegal characters are not allowed";
            },
            isValidFormat: function(value) {
                return /^.+@.+\..+$/.test(value);
            }
        }
    }
};
/* harmony default export */ var validators = (Validators);

// EXTERNAL MODULE: ./src/app/components/common/Loader.tsx
var Loader = __webpack_require__(41974);
;// CONCATENATED MODULE: ./src/app/components/forms/PortalLinkFormComp.tsx








var PortalLinkFormComp = function(props) {
    var ref;
    var name = props.name, extClassName = props.className, isLoading = props.isLoading, onSubmit = props.onSubmit, onError = props.onError, ref1 = (0,index_esm/* useForm */.cI)({
        defaultValues: {},
        mode: "onChange",
        reValidateMode: "onSubmit",
        shouldUnregister: false,
        shouldFocusError: true,
        delayError: undefined
    }), register = ref1.register, handleSubmit = ref1.handleSubmit, formState = ref1.formState, fieldErrors = formState.errors, isDirty = formState.isDirty, isValid = formState.isValid, classes = classnames_default()(extClassName);
    var emailRegs = register("email", validators.email);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        name: name,
        className: classes,
        onSubmit: handleSubmit(onSubmit, onError),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-azure",
                        htmlFor: "email",
                        children: "Email address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "email",
                        id: "email",
                        name: "email",
                        placeholder: "john.doe@gmail.com",
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        autoFocus: true,
                        className: classnames_default()("form-control", {
                            invalid: !!fieldErrors["email"]
                        })
                    }, !!fieldErrors["email"] && {
                        "aria-describedby": "emailTip"
                    }, emailRegs)),
                    !!fieldErrors["email"] && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        id: "emailTip",
                        className: "form-text text-warning mt-2 mb-5",
                        children: ((ref = fieldErrors["email"]) === null || ref === void 0 ? void 0 : ref.message) || "Invalid email address"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "btn btn-main btn-block py-3 mt-5",
                type: "submit"
            }, (!isDirty || !isValid || isLoading) && {
                disabled: true,
                "aria-disabled": true
            }), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                        size: 1
                    }) : "EMAIL ME A LINK"
                })
            }))
        ]
    });
};
/* harmony default export */ var forms_PortalLinkFormComp = (PortalLinkFormComp);

// EXTERNAL MODULE: ./src/app/http/base.ts
var base = __webpack_require__(45576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs + 2 modules
var _wrap_native_super = __webpack_require__(25892);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(91224);
;// CONCATENATED MODULE: ./src/app/models/HttpError.ts




var HttpError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(HttpError, Error1);
    var _super = (0,_create_super/* default */.Z)(HttpError);
    function HttpError(error, message, entities, status) {
        (0,_class_call_check/* default */.Z)(this, HttpError);
        var _this;
        _this = _super.call(this, message);
        _this.error = error;
        _this.entities = entities || [];
        _this.status = status;
        return _this;
    }
    return HttpError;
}((0,_wrap_native_super/* default */.Z)(Error));

;// CONCATENATED MODULE: ./pages/portal.tsx











var EmailInvitationStatus;
(function(EmailInvitationStatus) {
    EmailInvitationStatus[EmailInvitationStatus["ERROR"] = -1] = "ERROR";
    EmailInvitationStatus[EmailInvitationStatus["NOT_SENT"] = 0] = "NOT_SENT";
    EmailInvitationStatus[EmailInvitationStatus["SENT"] = 1] = "SENT";
})(EmailInvitationStatus || (EmailInvitationStatus = {}));
var ContactsPage = function(props) {
    var ref = (0,react.useState)(false), formLoading = ref[0], setFormLoading = ref[1], ref1 = (0,react.useState)({
        email: ""
    }), formValues = ref1[0], setFormValues = ref1[1], ref2 = (0,react.useState)(EmailInvitationStatus.NOT_SENT), invitationStatus = ref2[0], setInvitationStatus = ref2[1];
    var onEmailSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(formData) {
            var newFormValues, email, request;
            return (0,tslib_es6.__generator)(this, function(_state) {
                newFormValues = (0,_object_spread/* default */.Z)({}, formValues, formData);
                email = formData["email"];
                setFormValues(newFormValues);
                if (email) {
                    setFormLoading(true);
                    request = (0,base/* serverHttp */.B5)({
                        method: "GET",
                        url: "portal-sign-in",
                        params: {
                            email: email
                        }
                    }).request;
                    request.then(function(res) {
                        var data = res.data;
                        if (data) {
                            setInvitationStatus(EmailInvitationStatus.SENT);
                        } else {
                            throw new HttpError("no-email-sent", "Failed to send sign in link", [], 500);
                        }
                    }).catch(function() {
                        setInvitationStatus(EmailInvitationStatus.ERROR);
                    }).finally(function() {
                        setFormLoading(false);
                    });
                }
                return [
                    2,
                    true
                ];
            });
        });
        return function onEmailSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Meta contents
   */ var metaTitle = "Client Portal | Heritage Counseling", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = "".concat(constants/* META_URL */.f1, "/portals"), metaImage = "".concat(constants/* META_URL */.f1, "/logo.png");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: "Client Portal",
        fluidContainer: false,
        noPadding: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaImage
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaImage
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "portal-page common-form",
                "data-testid": "portal-page",
                children: [
                    invitationStatus === EmailInvitationStatus.NOT_SENT ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-center text-capitalize",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-envelope fa-3x d-block mb-5"
                                    }),
                                    "Instant sign in"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center mb-10",
                                children: "Get a link sent to your inbox to sign in—no password necessary."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_PortalLinkFormComp, {
                                name: "client-portal-form",
                                isLoading: formLoading,
                                onSubmit: onEmailSubmit
                            })
                        ]
                    }) : invitationStatus === EmailInvitationStatus.SENT ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-center text-capitalize mb-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-shipping-fast fa-3x d-block mb-5"
                                    }),
                                    "Your instant sign-in link is on the way"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-center mb-3",
                                children: [
                                    "If an account for ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: formValues.email
                                    }),
                                    " exists, you'll receive an email with the link."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center mb-10",
                                children: "The link expires in 24 hours and can only be used once."
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-center text-capitalize",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-times-circle fa-3x d-block mb-5"
                                    }),
                                    "Failed to send the link"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-center mb-10",
                                children: [
                                    "Please try to sign in from\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "aria-label": "Client Portal",
                                        "aria-hidden": "false",
                                        href: constants/* CLIENT_PORTAL_URL */.AI,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                children: "our client portal"
                                            })
                                        })
                                    }),
                                    "\xa0instead."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-testid": "signup-help",
                        className: "wrapper text-center mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "New client? Call\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "aria-label": "Sign up contact",
                                    "aria-hidden": "false",
                                    href: "tel:+12143632345",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "(214) 363-2345"
                                    })
                                }),
                                "\xa0to request an appointment."
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var portal = (ContactsPage);


/***/ }),

/***/ 41974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



var Loader = function(props) {
    var size = props.size, extClassName = props.className, sizeClass = size > 0 ? "fa-".concat(size, "x") : "", classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()("fa fa-spinner fa-pulse", sizeClass, extClassName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "block",
            textAlign: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: classes,
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 75019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_PageLayoutV1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/static/images/layout/layout-hero-1440.jpg
/* harmony default export */ var layout_hero_1440 = ({"src":"/_next/static/media/layout-hero-1440.020fe420.jpg","height":318,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIFElFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCRLWMQhZDbvjERJi//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/app/hocs/PageLayoutV1.tsx






var PageLayoutV1 = function(param) {
    var title = param.title, tagline = param.tagline, children = param.children, fluidContainer = param.fluidContainer, noPadding = param.noPadding;
    var isContainerFluid = (0,helpers/* isNullOrUndefined */.le)(fluidContainer) ? false : fluidContainer, containerClasses = classnames_default()("layout-container", {
        container: !isContainerFluid,
        "no-padding": !!noPadding
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-v1",
        "data-testid": "layout-v1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: layout_hero_1440.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title || "Heritage Consulting"
                        }),
                        tagline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tagline",
                            children: tagline
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClasses,
                children: children
            })
        ]
    });
};
/* harmony default export */ var hocs_PageLayoutV1 = (PageLayoutV1);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [868,774,888,179], function() { return __webpack_exec__(94404); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);